<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <p class=".title ma-2">Add a Q&A to {{huis.huis_code }} </p>
    <v-form ref="addHsva" v-model="addHsvaValid">

      
     <v-row no-gutters>
      <v-col class="ma-2">
       <v-select v-model="huis.taal_code" :items="taal_codeKeuzes" label="Language" :rules="taal_codeRules"></v-select>
      </v-col>
     </v-row>    

     <v-row no-gutters>
      <v-col class="ma-2">
         <v-textarea v-model="question" rows="5" label="Question" counter :rules="questionRules"></v-textarea>
      </v-col>
     </v-row>   

     <v-row no-gutters>
      <v-col class="ma-2">
         <v-textarea v-model="answer" rows="10" label="Answer" counter :rules="answerRules"></v-textarea>
      </v-col>
     </v-row>   

     
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addHsva" :disabled="!addHsvaValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>

    export default {
        data() { 
            return {
                dialog: false,
                addHsvaValid: false,
                huis_encrid: null,
                eign_code: '',
                taal_codeKeuzes: [],
                question: '',
                answer: '',
                huis: {},
                taal_codeRules: [
                    v => (v && v.length >= 2) || "A Language is requird"
                ],
                questionRules: [
                    v => (v && v.length >= 4) || "A 'Question' is requird"
                ],
                answerRules: [
                    v => (v && v.length >= 2) || "An 'Answer' is requird"
                ]
            }
        },
        methods: {
            open(huis_encrid) {
                var deze = this;
                this.dialog = true;
                this.$axios.post("ares/json/ares/huis/hsva/getHuisToAddHsva.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHuisToAddHsva"
                        },
                    getHuisToAddHsva: {
                        huis_encrid: huis_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.huis = res.data.getHuisToAddHsva;
                        res.data.getHuisToAddHsva.taal_codeKeuzes.forEach(function(rol) {
                            deze.taal_codeKeuzes.push(rol); 
                        });
                    }
                });
            },
            addHsva() { 
                this.addHsvaValid = false;
                this.$axios.post("ares/json/ares/huis/hsva/addHsva.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "addHsva"
                    },
                    addHsva: {
                        huis_encrid: this.huis.huis_encrid,
                        taal_code: this.huis.taal_code,
                        question: this.question,
                        answer: this.answer
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else { 
                        if (res.data.addHsva.color == "success") {                     
                            this.$emit("reload");
                        }
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: res.data.addHsva.text,
                            color: res.data.addHsva.color
                        }); 
                        this.dialog = false;
                    }
                });
            },
        }
    }
</script>

